import { ButtonVariant } from "@repo/ui/Buttons/button";
import { iconButton } from "@repo/ui/Buttons/iconButton";
import { dropdownMenu } from "@repo/ui/Dropdown/dropdownMenuStyles";
import {
  IconPencil as OutlinePencilIcon,
  IconPencil as SolidPencilIcon,
} from "@tabler/icons-react";
import type { FC } from "react";
import { DialogTrigger, Popover, ToggleButton } from "react-aria-components";
import {
  GradingAssessmentFeedbackDialog,
  type GradingAssessmentFeedbackDialogProps,
} from "./gradingAssessmentFeedbackDialog.js";

//
// Props.
//

interface GradingAssessmentFeedbackButtonProps extends GradingAssessmentFeedbackDialogProps {
  onOpenChange?: (isOpen: boolean) => void;
}

//
// Component.
//

export const GradingAssessmentFeedbackButton: FC<
  GradingAssessmentFeedbackButtonProps
> = (props) => {
  const { playbookId, node, recordingId } = props;
  const { grade, feedback, onOpenChange } = props;

  return (
    <DialogTrigger onOpenChange={onOpenChange}>
      <ToggleButton
        aria-label="Share assessment feedback"
        className={iconButton({
          variant: ButtonVariant.Tertiary,
          className: "pressed:bg-slate-200",
        })}
        isSelected={Boolean(feedback)}
      >
        {({ isSelected }) =>
          isSelected ? (
            <SolidPencilIcon className="size-4 shrink-0 text-indigo-600" />
          ) : (
            <OutlinePencilIcon className="size-4 shrink-0 text-gray-400" />
          )
        }
      </ToggleButton>

      <Popover placement="bottom end" className={dropdownMenu().popover()}>
        <GradingAssessmentFeedbackDialog
          playbookId={playbookId}
          node={node}
          recordingId={recordingId}
          grade={grade}
          feedback={feedback}
        />
      </Popover>
    </DialogTrigger>
  );
};
